import * as React from 'react';
import { Application, IApplicationContext } from '../../../../shared/App';
import { Store } from 'redux';
import { IApplicationState } from '../../../../shared/types/redux';

export function getFavoritesPage(context: IApplicationContext, store: Store<IApplicationState>) {
  return <Application context={context} store={store} />;
}
